//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data(){
		return{
			images:[]
		}
	},
	onLoad(e) {
		this.images=e.image.split(',').map(res=>{
			return this.$getImg(res)
			
		})
	},
	methods:{
		preview(i){				
			uni.previewImage({
				current:i,
				urls:this.images,
				indicator:'default'
			})
		}
	}		
}
